const ACCIDENT_QUESTION = [
    {
        name: 'clarifyAccident',
        transKey: 'TRADE_IN.VEHICLE_INFORMATION.CLARIFY_ACCIDENT',
        inputType: 'textarea',
        classNames: 'full',
    },
    {
        name: 'bodyPartReplaced',
        transKey: 'TRADE_IN.VEHICLE_INFORMATION.BODY_PARTS_REPLACED.TITLE',
        inputType: 'radio',
        options: [
            {
                transKey: 'TRADE_IN.VEHICLE_INFORMATION.BODY_PARTS_REPLACED.YES',
                value: true,
            },
            {
                transKey: 'TRADE_IN.VEHICLE_INFORMATION.BODY_PARTS_REPLACED.NO',
                value: false,
            },
        ],
        classNames: 'full',
    },
    {
        name: 'absOperational',
        transKey: 'TRADE_IN.VEHICLE_INFORMATION.ABS_OPERATIONAL.TITLE',
        inputType: 'radio',
        options: [
            {
                transKey: 'TRADE_IN.VEHICLE_INFORMATION.ABS_OPERATIONAL.YES',
                value: true,
            },
            {
                transKey: 'TRADE_IN.VEHICLE_INFORMATION.ABS_OPERATIONAL.NO',
                value: false,
            },
        ],
        classNames: 'full',
    },
];

const CAR_CONDITION_QUESTION = [
    {
        name: 'hadAnAccident',
        transKey: 'TRADE_IN.VEHICLE_INFORMATION.EVER_HAD_AN_ACCIDENT.TITLE',
        inputType: 'radio',
        options: [
            {
                transKey: 'TRADE_IN.VEHICLE_INFORMATION.EVER_HAD_AN_ACCIDENT.NONE',
                value: 'none',
            },
            {
                transKey: 'TRADE_IN.VEHICLE_INFORMATION.EVER_HAD_AN_ACCIDENT.LESS_THAN_3000',
                value: 'lessThan3000',
            },
            {
                transKey: 'TRADE_IN.VEHICLE_INFORMATION.EVER_HAD_AN_ACCIDENT.3000_AND_MORE',
                value: '3000AndMore',
            },
        ],
        classNames: 'full',
        showSubQuestionsValue: '3000AndMore',
        subQuestions: ACCIDENT_QUESTION,
    },
    {
        name: 'airBagsOperational',
        transKey: 'TRADE_IN.VEHICLE_INFORMATION.AIR_BAGS_OPERATIONAL.TITLE',
        inputType: 'radio',
        options: [
            {
                transKey: 'TRADE_IN.VEHICLE_INFORMATION.AIR_BAGS_OPERATIONAL.YES',
                value: true,
            },
            {
                transKey: 'TRADE_IN.VEHICLE_INFORMATION.AIR_BAGS_OPERATIONAL.NO',
                value: false,
            },
        ],
        classNames: 'full',
    },
    {
        name: 'modifiedParts',
        transKey: 'TRADE_IN.VEHICLE_INFORMATION.MODIFIED_PARTS.TITLE',
        inputType: 'radio',
        options: [
            {
                transKey: 'TRADE_IN.VEHICLE_INFORMATION.MODIFIED_PARTS.YES',
                value: true,
            },
            {
                transKey: 'TRADE_IN.VEHICLE_INFORMATION.MODIFIED_PARTS.NO',
                value: false,
            },
        ],
        classNames: 'full',
    },
    {
        name: 'partsToReplace',
        transKey: 'TRADE_IN.VEHICLE_INFORMATION.PARTS_TO_REPLACE.TITLE',
        inputType: 'checkbox',
        options: [
            {
                transKey: 'TRADE_IN.VEHICLE_INFORMATION.PARTS_TO_REPLACE.OPTIONS.NONE',
                value: 'none',
            },
            {
                transKey: 'TRADE_IN.VEHICLE_INFORMATION.PARTS_TO_REPLACE.OPTIONS.ENGINE',
                value: 'engine',
            },
            {
                transKey: 'TRADE_IN.VEHICLE_INFORMATION.PARTS_TO_REPLACE.OPTIONS.SUSPENSION',
                value: 'suspension',
            },
            {
                transKey: 'TRADE_IN.VEHICLE_INFORMATION.PARTS_TO_REPLACE.OPTIONS.TRANSMISSIONS',
                value: 'transmission',
            },
            {
                transKey: 'TRADE_IN.VEHICLE_INFORMATION.PARTS_TO_REPLACE.OPTIONS.POWER_TRAIN',
                value: 'powertrain',
            },
            {
                transKey: 'TRADE_IN.VEHICLE_INFORMATION.PARTS_TO_REPLACE.OPTIONS.COMPUTER',
                value: 'computer',
            },
            {
                transKey: 'TRADE_IN.VEHICLE_INFORMATION.PARTS_TO_REPLACE.OPTIONS.ELECTRICAL',
                value: 'electrical',
            },
            {
                transKey: 'TRADE_IN.VEHICLE_INFORMATION.PARTS_TO_REPLACE.OPTIONS.FUEL_OPERATION_SYSTEM',
                value: 'fuelOperationSystem',
            },
            {
                transKey: 'TRADE_IN.VEHICLE_INFORMATION.PARTS_TO_REPLACE.OPTIONS.AIR_CONDITIONING_SYSTEM',
                value: 'airConditioningSystem',
            },
            {
                transKey: 'TRADE_IN.VEHICLE_INFORMATION.PARTS_TO_REPLACE.OPTIONS.OTHER',
                value: 'other',
            },
        ],
        classNames: 'full',
    },
];

const EXPLAIN_REPARATION = [
    {
        name: 'needReparationOtherExplanation',
        transKey: 'TRADE_IN.VEHICLE_INFORMATION.PARTS_TO_REPLACE.OTHER_EXPLANATION',
        inputType: 'textarea',
        classNames: 'full',
    },
];

const CAR_CONDITION = [
    {
        name: 'replacedTires',
        transKey: 'TRADE_IN.VEHICLE_INFORMATION.REPLACED_TIRES.TITLE',
        inputType: 'radio',
        options: [
            {
                transKey: 'TRADE_IN.VEHICLE_INFORMATION.REPLACED_TIRES.YES',
                value: true,
            },
            {
                transKey: 'TRADE_IN.VEHICLE_INFORMATION.REPLACED_TIRES.NO',
                value: false,
            },
        ],
        classNames: 'full',
    },
    {
        name: 'replacedBrakes',
        transKey: 'TRADE_IN.VEHICLE_INFORMATION.REPLACED_BRAKES.TITLE',
        inputType: 'radio',
        options: [
            {
                transKey: 'TRADE_IN.VEHICLE_INFORMATION.REPLACED_BRAKES.YES',
                value: true,
            },
            {
                transKey: 'TRADE_IN.VEHICLE_INFORMATION.REPLACED_BRAKES.NO',
                value: false,
            },
        ],
        classNames: 'full',
    },
    {
        name: 'anyScratches',
        transKey: 'TRADE_IN.VEHICLE_INFORMATION.ANY_SCRATCHES.TITLE',
        inputType: 'radio',
        options: [
            {
                transKey: 'TRADE_IN.VEHICLE_INFORMATION.ANY_SCRATCHES.YES',
                value: true,
            },
            {
                transKey: 'TRADE_IN.VEHICLE_INFORMATION.ANY_SCRATCHES.NO',
                value: false,
            },
        ],
        classNames: 'full',
    },
    {
        name: 'damageExceeding3000',
        transKey: 'TRADE_IN.VEHICLE_INFORMATION.DAMAGE_EXCEEDING_3000.TITLE',
        inputType: 'radio',
        options: [
            {
                transKey: 'TRADE_IN.VEHICLE_INFORMATION.ANY_SCRATCHES.YES',
                value: true,
            },
            {
                transKey: 'TRADE_IN.VEHICLE_INFORMATION.ANY_SCRATCHES.NO',
                value: false,
            },
        ],
        classNames: 'full',
    },
    {
        name: 'majorExteriorInteriorDamage',
        transKey: 'TRADE_IN.VEHICLE_INFORMATION.MAJOR_EXTERIOR_INTERIOR_DAMAGE.TITLE',
        inputType: 'radio',
        options: [
            {
                transKey: 'TRADE_IN.VEHICLE_INFORMATION.MAJOR_EXTERIOR_INTERIOR_DAMAGE.YES',
                value: true,
            },
            {
                transKey: 'TRADE_IN.VEHICLE_INFORMATION.MAJOR_EXTERIOR_INTERIOR_DAMAGE.NO',
                value: false,
            },
        ],
        classNames: 'full',
    },
];

const VEHICLE_DAMAGE = [
    {
        name: 'clarifyDamage',
        transKey: 'TRADE_IN.VEHICLE_INFORMATION.CLARIFY_ACCIDENT',
        inputType: 'textarea',
        classNames: 'full',
    },
];

const carConditionQuestions = {
    CAR_CONDITION,
    CAR_CONDITION_QUESTION,
    ACCIDENT_QUESTION,
    EXPLAIN_REPARATION,
    VEHICLE_DAMAGE,
};

export default carConditionQuestions;
